import * as z from "zod";
import {
  BomTemplateBindingSummary,
  bomTemplateBindingStatusSchema,
} from "./bom-template-types";

export const listBomTemplateBindings = {
  name: "listBomTemplateBindings" as const,
  input: z.object({ status: bomTemplateBindingStatusSchema.optional() }),
  output: z.object({ bindings: z.array(BomTemplateBindingSummary) }),
};
